import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { faq } from '../cherryWebContent';

const Faq = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 2, md: 3 }}>
      <SectionHeader overline={faq.overline} title={faq.title} icon="help" />
      <Box maxWidth={760} mx="auto">
        {faq.items.map((item, index) => (
          <Accordion
            key={item.question}
            data-aos="fade-up"
            elevation={0}
            sx={{
              mb: 1.5,
              borderRadius: '16px !important',
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: alpha(theme.palette.common.white, 0.92),
              '&:before': { display: 'none' },
              overflow: 'hidden',
            }}
            defaultExpanded={index === 0}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                px: 2.5,
                '& .MuiAccordionSummary-content': { my: 1.5, alignItems: 'center', gap: 12 },
              }}
            >
              <IconBadge icon={item.icon} variant="soft" size={40} rounded="12px" />
              <Typography sx={{ fontWeight: 700 }}>{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{ px: 2.5, pt: 0, pb: 2.5, bgcolor: alpha(theme.palette.grey[500], 0.04) }}
            >
              <Typography
                color="textSecondary"
                sx={{ lineHeight: 1.75, pl: { xs: 0, sm: 6.5 } }}
              >
                {item.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default Faq;
